import React, { useState, useEffect } from "react";
import {
    faEnvelopeOpenText,
    faMapMarkerAlt,
    faPhoneAlt,
    faBuilding,
    faCity 
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FaAngleRight } from 'react-icons/fa';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import axiosInstance from "../apis/axiosInstance";
import { saveContact, verifyOtp, resendOtp } from '../apis/SaveContactAPI';

const contactInfoList = [
	{
		icon: faEnvelopeOpenText,
		label: " info@infrec.in",
		href: "mailto: info@infrec.in",
	},
	{
		icon: faPhoneAlt,
		label: "+91 9279123466",
		href: "callto: +91 9279123466",
	},
	{ icon: faBuilding, label: "INFREC CONSULTANCY SERVICES (OPC) Pvt Ltd Office No. 502, 5th Floor, Beside Timmy Arcade, Jai Antariksh, Makwana Rd, Gamdevi, Marol, Andheri East, Mumbai, Maharashtra 400059"}   
];

const ContactForm = () => {
    const [formData, setFormData] = useState({ name: "", email: "", mobile: "", message: "" });
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [validated, setValidated] = useState(false);
    const [timer, setTimer] = useState(120);
    const [isTimerActive, setIsTimerActive] = useState(false);
    const [contactId, setContactId] = useState(null); // Store contactId
    const [isResendDisabled, setIsResendDisabled] = useState(false); // Disable button temporarily

    useEffect(() => {
        let interval;
        
        if (isTimerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0 && isTimerActive) {
            // Prevent showing OTP expiry if OTP is already verified
            if (!isOtpVerified) {
                toast.error("OTP expired! Please request a new one.");
            }
            setIsTimerActive(false);
            setIsResendDisabled(false);
        }
    
        return () => clearInterval(interval);
    }, [isTimerActive, timer, isOtpVerified]);  // Add `isOtpVerified` as a dependency
    



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOtpChange = (index, value) => {
        if (value.length > 1) return; 

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };


    const validateMobileNumber = (number) => {
        const mobileRegex = /^[6-9]\d{9}$/;
        return mobileRegex.test(number);
    };

    const handleSendOtp = async () => {
        if (!formData.name || !formData.email || !formData.mobile || !formData.message) {
            toast.error("All fields are required!");
            return;
        }
        if (!validateMobileNumber(formData.mobile)) {
            toast.error("Invalid mobile number!");
            return;
        }
    
        try {
            const contactResponse = await saveContact(formData);
    
            if (contactResponse.contactId || contactResponse.message) {
                toast.success(contactResponse.message);
    
                setIsOtpSent(true);
                setIsTimerActive(true);
                setTimer(120);
                setIsResendDisabled(true);
                setContactId(contactResponse.contactId);
            } else {
                toast.error(contactResponse.message || "Failed to send OTP.");
            }
        } catch (error) {
            toast.error("An error occurred while sending OTP.");
        }
    };

    const handleResendOtp = async () => {
        if (!contactId) {
            toast.error("Incorrect request! Please try again.");
            return;
        }
   
        setIsResendDisabled(true);
   
        try {
            const response = await resendOtp(contactId);
            
            if (response.success) {
                toast.success(response.message || "OTP resent successfully!");
                setTimer(120);
                setIsTimerActive(true);
                setIsResendDisabled(true);
            } else {
                toast.error(response.message || "Failed to resend OTP.");
            }
        } catch (error) {
            toast.error("Error resending OTP.");
        }
    };


    const handleVerifyOtp = async () => {
        const enteredOtp = otp.join(""); 
    
        if (enteredOtp.length < 6) {
            toast.error("Please enter a valid 6-digit OTP.");
            return;
        }
    
        try {
            const response = await verifyOtp(formData.mobile, enteredOtp);
    
            if (response.success) {
                toast.success(response.message);
                setIsOtpVerified(true);
                setIsTimerActive(false);
                setTimer(null);
                setIsOtpSent(false);
                setContactId(null);
                setOtp(["", "", "", "", "", ""]);
                setFormData({ name: "", email: "", mobile: "", message: "" });
            } else {
                toast.error(response.message || "Invalid OTP. Try again.");
            }
        } catch (error) {
            toast.error("Error verifying OTP.");
        }
    };
    
    
   





    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isOtpVerified) {
            toast.error("Please verify OTP before submitting.");
            return;
        }

        toast.success("Form submitted successfully!");
        setFormData({ name: "", email: "", mobile: "", message: "" });
        setIsOtpSent(false);
        setIsOtpVerified(false);
        setOtp(["", "", "", "", "", ""]);
    };


    return (
        <form className="" noValidate validated={validated} onSubmit={handleSubmit}>
            <ToastContainer />
            <div className="mb-4">
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="min-h-[48px] leading-[48px] bg-white border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
                    placeholder="Enter Name"
                />
            </div>
            <div className="mb-4">
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="min-h-[48px] leading-[48px] bg-white border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
                    placeholder="Enter Email"
                />
            </div>
            <div className="mb-4">
                <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    className="min-h-[48px] leading-[48px] bg-white border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
                    placeholder="Enter contact number"
                />
            </div>
            <div className="mb-4">
                <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="min-h-[48px] leading-[48px] bg-white border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
                    placeholder="Enter Message"
                    rows="2"
                ></textarea>
            </div>

            {!isOtpSent ? (
            <button
                type="button"
                onClick={handleSendOtp}
                className="bg-darkBlue hover:bg-opacity-90 text-white px-8 py-3 rounded mb-4"
            >
                Send OTP
            </button>
        ) : (
            <>
                <div className="text-center space-x-2 mb-4">
                    {/* ⏳ Timer Display */}
                    {isTimerActive && (
                        <div className="text-center mt-2 text-red-500 mb-4">
                            Time remaining: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
                        </div>
                    )}

                    {/* OTP Input Fields */}
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            id={`otp-${index}`} 
                            type="text"
                            value={digit}
                            onChange={(e) => handleOtpChange(index, e.target.value)}
                            maxLength="1"
                            className="w-12 h-12 text-center border rounded"
                        />
                    ))}

                    {/* Submit Button */}
                    <button 
                        type="button" 
                        onClick={handleVerifyOtp} 
                        className={`text-white mt-5 px-2 py-1 rounded ${isOtpVerified ? 'bg-green-500' : 'bg-gray-500'}`}
                    >
                        Submit
                    </button>
                </div>

                {/* ✅ Resend OTP Section */}
                {!isTimerActive && (
                    <div className="text-center">
                        <button 
                            type="button" 
                            onClick={handleResendOtp} 
                            disabled={isResendDisabled} 
                            className="mt-2 text-blue-500 hover:underline disabled:opacity-50"
                        >
                            Resend OTP
                        </button>
                    </div>
                )}
            </>
        )}

        </form>
    );
};

const ContactFormCard = () => (
    <div className="bg-skyBlue shadow-xl rounded-2xl p-6 md:p-12">
        <h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
            Contact Us
        </h2>
        <p className="text-lg mb-12">
            We list your menu online, process orders, and offer financial or insurance solutions.
        </p>

        <ContactForm />
    </div>
);

const ContactInfo = ({ contactInfoList }) => (
    <div classNameName="mt-5 pt-md-4">
        {contactInfoList.map((info, i) => (
            <div
                className="bg-skyBlue shadow max-w-[550px] mt-6 flex items-center rounded-xl p-5"
                key={i}
            >
                <FontAwesomeIcon icon={info.icon} className="text-3xl px-2" />
                <i className="fas fa-envelope-open-text text-3xl px-2"></i>
                <a className="text-lg font-medium ml-4" href={info.href || "#!"}>
                    {info.label}
                </a>
            </div>
        ))}
    </div>
);

ContactInfo.propTypes = {
    contactInfoList: PropTypes.array.isRequired,
};

const Contact = () => {
    return (
        <React.Fragment>
            <section className="bg-darkBlue text-white min-h-[30vh] md:min-h-[30vh] flex items-center justify-center" style={{ paddingTop: '0.5rem' }}>
                <div className="max-w-7xl px-4 mx-auto">
                    <div className="grid grid-cols-12 items-center justify-center">
                        <div className="col-span-12 text-center">
                            <div className="py-8">
                                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold mb-4 pt-12 md:pt-10">
                                    Contact Us
                                </h2>
                                <p className="text-lg opacity-80">Get in touch with us for any inquiries</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ezy__contact9 light py-14 md:py-24 bg-white overflow-hidden">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-12 py-6 lg:gap-8">
                        <div className="col-span-12 lg:col-span-5 mb-12 lg:mb-0">
                            <h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-6 uppercase">
                                How can we help you?
                            </h2>
                            <p className="text-lg">
                                Reach your savings goals with the right account explore your options today!
                            </p>

                            <ContactInfo contactInfoList={contactInfoList} />
                        </div>

                        <div className="col-span-12 lg:col-span-5 lg:col-start-8">
                            <ContactFormCard />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};


export default Contact
